import { useQuery } from '@apollo/client';
import {SectionLayout} from './section-layout';
import { ApplicantSectionLayoutContainerApplicantUserCurrentDocument } from '../../../generated';
import { ComponentQueryLoader } from '../../shared/component-query-loader';

interface SectionLayoutContainerProps {}

export const SectionLayoutContainer: React.FC<SectionLayoutContainerProps> = () => {
  const { data, loading, error } = useQuery(ApplicantSectionLayoutContainerApplicantUserCurrentDocument);
  return (
    <ComponentQueryLoader
      loading={loading}
      error={error}
      hasData={data?.applicantUserCurrent}
      hasDataComponent={<SectionLayout isAccessBlocked={data?.applicantUserCurrent?.accessBlocked as boolean} />}
    />
  );
};

